import { motion } from "framer-motion";

const VIDEOS = [
  { id: "gwHgz5z5D48", caption: "The energy on the floor" },
  { id: "hRRRbINQjQo", caption: "The joy in the room" },
];

export function VideoShowcase() {
  return (
    <section id="vibe" className="border-t border-[#33240E]/15 py-32" data-testid="video-showcase">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="mb-16 grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.4em] text-[#8A5A0F]">Straight From the Floor</p>
            <h2 className="font-serif text-4xl font-black text-[#33240E] sm:text-5xl lg:text-6xl">
              Don't take our word for it<span className="text-velvet">.</span><br />
              <span className="italic text-[#8A5A0F]">Feel the vibe.</span>
            </h2>
          </div>
          <p className="max-w-md self-end text-base font-light leading-relaxed text-muted-foreground lg:col-span-5">
            Real moments from our events — the music, the hugs, the joy. December 12 is all of this,
            turned all the way up.
          </p>
        </div>

        <div className="grid gap-12 sm:grid-cols-2 lg:gap-20">
          {VIDEOS.map((v, i) => (
            <motion.figure
              key={v.id}
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.15 }}
              className={`mx-auto w-full max-w-sm ${i === 1 ? "sm:mt-24" : ""}`}
            >
              <div className="relative">
                <div className="absolute -right-4 -top-4 h-full w-full border border-[#33240E]/30" />
                <div className="relative overflow-hidden bg-black">
                  <iframe
                    src={`https://www.youtube.com/embed/${v.id}?rel=0&modestbranding=1&playsinline=1&loop=1&playlist=${v.id}`}
                    title={v.caption}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="aspect-[9/16] w-full"
                    data-testid={`video-frame-${i + 1}`}
                  />
                </div>
              </div>
              <figcaption className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                Fig. 0{i + 3} — {v.caption}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
